/**
 * Get URLs to square versions of an Instagram photo.
 *
 * @param {*} photo The instagram photo object, as returned by their API.
 * @return Object An object with `small` and `large` URLs.
 */
function instagramSquared(photo) {
  var response = { small:'', large:'', thumbnail:'' };

  // At a bare minimum we need the following:
  if (!photo || !photo.images || !photo.images.standard_resolution) {
    console.error('Instagram: can not parse photo data.');
    return response;
  }

  // Set fallbacks in case we can't resize
  response.large = photo.images.standard_resolution.url;
  response.small = photo.images.low_resolution
    ? photo.images.low_resolution.url
    : photo.images.standard_resolution.url;
  response.thumbnail = photo.images.thumbnail
    ? photo.images.thumbnail.url
    : photo.images.standard_resolution.url;

  // We need the cropping information from the thumbnail URL
  if (!photo.images.thumbnail) return response;

  // Crop each size
  response.large = getSquareUrl(response.large, photo, 'standard_resolution');
  response.small = getSquareUrl(response.small, photo, 'low_resolution');

  return response;
}

/**
 * Resize the template URL based off another URL's sizes.
 *
 * This pulls the size information from one URL (in a format like `s320x320`)
 * and and moves it to another URL.
 *
 * This lets us use the cropping information from one URL, and the sizing
 * information from another. Currently, only the thumbnail size has the crop
 * info, so the templateU
 *
 * @param url
 *        An Instagram photo URL to pull the sizing information from.
 *
 * @param templateUrl
 *        An Instagram photo URL that has cropping information.
 */
function getSquareUrl(url, photo, image) {
  var templateUrl = photo.images.thumbnail.url;
  var sizes = url.match(/\/[ps]([0-9]+)x([0-9]+)\//);

  // The target image URL does not have size information...
  if (!sizes || sizes.length < 3) {
    // In the worst case, return the thumbnail URL as a fallback
    if (!photo.images[image]) return templateUrl;

    // But try to pull the target resolution size from the photo object otherwise
    var templateEdge = Math.min(
      photo.images.thumbnail.width,
      photo.images.thumbnail.height
    );

    var edge = Math.min(
      photo.images[image].width,
      photo.images[image].height
    );

    return templateUrl.replace(templateEdge + 'x' + templateEdge, edge + 'x' + edge);
  }

  // Best case: use the target image URL sizes.
  var size = Math.round(Math.max(
    parseInt(sizes[1], 10),
    parseInt(sizes[2], 10)
  ));

  return templateUrl.replace(
    /\/[ps][0-9]+x[0-9]+\//,
    "/s" + size + "x" + size + "/"
  );
}

// If copying to a Coffeescript file, skip this line:
module.exports = instagramSquared;
